import api from './client';
import { Timestamp } from 'firebase/firestore';
import type { FormTemplate } from 'types/generated_document';

function toTimestamp(value: any): Timestamp {
  if (!value) return Timestamp.now();
  if (value instanceof Timestamp) return value;
  if (typeof value === 'string') {
    return Timestamp.fromDate(new Date(value));
  }
  if (value.seconds !== undefined) {
    return new Timestamp(value.seconds, value.nanoseconds || 0);
  }
  return Timestamp.now();
}

function apiResponseToFormTemplate(response: any): FormTemplate {
  return {
    ...response,
    created_at: toTimestamp(response.created_at),
  };
}

export const formTemplatesApi = {
  list: async (params?: { org_id?: string; limit?: number }): Promise<FormTemplate[]> => {
    const { data } = await api.get('/form-templates', { params });
    return (data as any[]).map(apiResponseToFormTemplate);
  },

  create: async (template: Omit<FormTemplate, 'id' | 'created_at'> & { org_id: string }): Promise<FormTemplate> => {
    const { data } = await api.post('/form-templates', template);
    return apiResponseToFormTemplate(data);
  },

  update: async (templateId: string, updates: Partial<FormTemplate>): Promise<FormTemplate> => {
    const { data } = await api.patch(`/form-templates/${templateId}`, updates);
    return apiResponseToFormTemplate(data);
  },

  delete: async (templateId: string): Promise<void> => {
    await api.delete(`/form-templates/${templateId}`);
  },
};
